export default __webpack_public_path__ + "static/media/19.6837f724.png";